module.exports = __webpack_public_path__ + "img/20190918172331014.70c13e0e.jpg";